import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDetailAllUkm, versions } from '../pages/ukmData';
import Sections from './Sections';
import styles from '../components/DetailUkm.module.css';
import styles1 from '../pages/Faq.module.css';
import classnames from 'classnames';
import Carousel from 'react-elastic-carousel';

const DetailUkm = () => {
	let { slug } = useParams();
	const [clicked, setClicked] = useState(false);
	const [idActive, setIdActive] = useState(0);
	const breakPoints = [{ width: 1, itemsToShow: 1 }];
	const handleClick = (id) => {
		setClicked(!clicked);
		setIdActive(id);
	};
	const [dataDetail, setDataDetail] = useState();
	const getDataBySlug = () => {
		let data = JSON.parse(localStorage.getItem('data'));
		data = data.filter((data) => data.slug === slug);
		setDataDetail(data);
	};
	const getData = () => {
		axios.get(`https://jsonplaceholder.typicode.com/photos`).then((res) => {
			localStorage.setItem('data', JSON.stringify(getDetailAllUkm));
			getDataBySlug();
		});
	};

	useEffect(() => {
		if (
			localStorage.getItem('data') === null ||
			JSON.parse(localStorage.getItem('version')) !== versions
		) {
			getData();
			localStorage.setItem('version', JSON.stringify(versions));
			console.log('fetching to server....');
		} else {
			getDataBySlug();
			console.log('fetching to local...');
		}
		return () => {
			getDataBySlug();
		};
	}, []);

	return (
		<div className="bg-yellowPucat">
			<Sections
				propsClass={`justify-center items-start min-h-screen relative bg-yellowPucat`}
				propsClass2={'mt-25 lg:mb-5 xl:mb-5 w-full'}
			>
				{/* {dataDetail && <div> Loading... </div>} */}
				{dataDetail &&
					dataDetail.map((data) => {
						return (
							<div key={data.id}>
								<div className="flex items-center space-x-3">
									<img
										src={`${process.env.PUBLIC_URL}/assets/ukm/logo/tes.png`}
										alt="tes"
										className="w-full max-w-ospekFakIcon"
									/>
									<h1 className="text-redUkm font-bold text-2xl">
										{data.nama}
									</h1>
								</div>

								<div
									key={data.id}
									className="grid grid-cols-2 gap-5 my-10 xs:grid-cols-1"
								>
									<div>
										<div className={`${styles.galeriUkm}`}>
											<Carousel
												breakPoints={breakPoints}
												className="space-x-2"
											>
												{data.galeri.map((dataGaleri, index) => {
													return (
														<img
															src={`${process.env.PUBLIC_URL}/assets/jumbotronGaleri.png`}
															alt="s"
															key={index}
														/>
													);
												})}
											</Carousel>
										</div>
									</div>
									<div>
										<div
											className={` ${styles.profileVideoUkm} bg-redUkm`}
										>
											<iframe
												title="Youtube Video"
												src={`${data.video_profile.replace(
													'https://youtu.be/',
													'https://www.youtube.com/embed/'
												)}`}
												className="my-0 mx-auto"
												width="100%"
												frameBorder="0"
												height="100%"
											/>
										</div>
									</div>
									<div className="">
										<h1 className="text-redUkm font-bold text-2xl mb-2">
											Sekilas UKM
										</h1>
										<p className="text-md">{data.sekilas}</p>
									</div>
									<div>
										<h1 className="text-redUkm font-bold text-2xl mb-2">
											Prestasi UKM
										</h1>
										<ul className="text-md">
											{data.prestasi.map((dataPrestasi, index) => {
												return (
													<li key={index}>
														- {dataPrestasi.nama_prestasi}
													</li>
												);
											})}
										</ul>
									</div>
									<div>
										<h1 className="text-redUkm font-bold text-2xl mb-2">
											Deskripsi UKM
										</h1>
										<p className="text-md">{data.deskripsi}</p>
									</div>
									<div>
										<h1 className="text-redUkm font-bold text-2xl mb-2">
											Pesan UKM
										</h1>
										<p className="text-md">{data.pesan}</p>
										<p className="text-md">
											Open Recruitmen: {data.tanggal_oprec}
										</p>
										<p className="text-md">
											Link Open Recruitmen: {data.link_oprec}
										</p>
									</div>
									<div>
										<h1 className="text-redUkm font-bold text-2xl mb-2">
											Media Sosial UKM
										</h1>
										<ul className="text-md space-y-2">
											{data.sosmed.map((dataSosmed, index) => {
												return (
													<li className="flex items-center space-x-2" key={index}>
														<img
															src={`${process.env.PUBLIC_URL}/assets/ukm/sosmed/ig.png`}
															alt="ig"
														/>
														<p className="text-md">
															{dataSosmed.link}
														</p>
													</li>
												);
											})}
										</ul>
									</div>
								</div>
							</div>
						);
					})}
			</Sections>
			<Sections
				propsClass={`justify-center items-start min-h-screen relative bg-redUkm-bg bg-no-repeat bg-top bg-cover`}
				propsClass2={'my-25 lg:mb-5 xl:mb-5 w-full'}
			>
				<h1 className="text-white font-bold text-2x text-center mb-10">
					Kegiatan UKM
				</h1>

				<div className="">
					{dataDetail &&
						dataDetail.map((data, index) => {
							return (
								<div className="grid grid-cols-3 gap-5 xs:grid-cols-1" key={index}>
									{data.kegiatan.map((dataKegiatan, index) => {
										return (
											<div
												className={`${styles.cardKegiatan} text-center p-5`}
                        key={index}
											>
												<h1 className="text-white font-bold text-xl mb-2">
													{dataKegiatan.nama_kegiatan}
												</h1>
												<p className="text-md text-white mt-5">
													{dataKegiatan.deskripsi}
												</p>
											</div>
										);
									})}
								</div>
							);
						})}
				</div>

				<h1 className="text-white font-bold text-2x text-center my-10">
					FAQ UKM
				</h1>

				<div>
					{dataDetail &&
						dataDetail.map((data, indexs) => {
							return (
								<div key={indexs}>
									{data.faq.map(({ question, answer }, index) => {
										return (
											<div
												className={`${styles.a1} mt-2`}
												onClick={() => handleClick(index)}
												key={index}
											>
												<div
													className={`${styles.ask} ${
														clicked && idActive === index
															? 'bg-yellowPucat text-black'
															: 'bg-greenDetail text-purpleMaghrib'
													}`}
												>
													<h1>{question}</h1>
													<img
														src={`${process.env.PUBLIC_URL}/assets/faqIcon.svg`}
														alt="icon"
														className={`${styles.faqIcon}`}
													/>
												</div>
												<div
													className={classnames(
														styles.ans,
														clicked && idActive === index
															? `${styles.show} 'bg-white'`
															: ''
													)}
												>
													<p>{answer}</p>
												</div>
											</div>
										);
									})}
								</div>
							);
						})}
				</div>
			</Sections>
		</div>
	);
};

export default DetailUkm;
